import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface CommentQualifier {
  label: string;
  value: string;
  flag?: Maybe<string>;
  properties?: Record<string, unknown>;
}

export type GetCommentQualifiersResponse = {
  qualifiers: CommentQualifier[];
};

export async function getLTLCommentQualifiers(): Promise<
  Result<GetCommentQualifiersResponse, ApiError>
> {
  try {
    const response = await axios.get<GetCommentQualifiersResponse>(
      '/quote/ltl/comment-qualifiers'
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLCommentQualifiers' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get LTL comment qualifiers' });
    }

    return err({
      message:
        error.response?.data?.message || 'Failed to get LTL comment qualifiers',
    });
  }
}
